import React from 'react';
import { ButtonV2 } from '@getgrover/ui';
import { useLogin } from './useLogin';

export const LocalDevAuthButton = () => {
  const { login } = useLogin();
  return <ButtonV2 onClick={login}>Login</ButtonV2>;
};
